import { ReactiveFormsModule, FormsModule } from '@angular/forms';

import { Component, ChangeDetectionStrategy, LOCALE_ID, input, output, inject } from '@angular/core';
import { StyleClassModule } from 'primeng/styleclass';
import { TranslateModule} from '@ngx-translate/core';
import { DrawerModule } from 'primeng/drawer';
import { Observable } from 'rxjs';
import {ClientProfileComponent} from '../client-profile/client-profile.component'

@Component({
  selector: 'fitness-force-client-info-sidebar',
  templateUrl: './client-info-sidebar.component.html',
  styleUrls: ['./client-info-sidebar.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [
    ReactiveFormsModule,
    FormsModule,
    StyleClassModule,
    DrawerModule,
    ClientProfileComponent,
    TranslateModule
]
})
export class ClientInfoSidebarComponent {
  locale = inject(LOCALE_ID);

  readonly showClientSidebar = input<boolean>(false);
  readonly activeClientId = input<number>(0);
  readonly interactionId = input<number>(0);
  readonly activeTab = input<string>('overview');
  readonly activeSubTab = input<string>('');
  readonly closeSidebar = output<boolean>();

  public companyInfoDetail$!: Observable<any>;


  CloseSidebar() {
    this.closeSidebar.emit(false);
  }

  closeClientSidebar()
  {
    this.closeSidebar.emit(false);
  }
}
